/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Configuration Service API
 * Documentation of the controllers and endpoints used in the configuration-service.
 * OpenAPI spec version: deploy-only-master-3011
 */
import type {
  MainWebShop,
  StoreInfoDTO,
  StoreOpenDayAndHourScheduleDTO,
} from '@as-react/common-types/configuration-service';
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';
import type { RequestHandlerOptions } from 'msw';

export const getGetAllStoresScheduleServerResponseMock = (): Array<StoreOpenDayAndHourScheduleDTO> =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    address: faker.helpers.arrayElement([
      {
        street: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        number: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        bus: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        zipCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        city: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        country: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      },
      undefined,
    ]),
    scheduleEntries: faker.helpers.arrayElement([
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        openingHour: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        closingHour: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        day: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        date: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        closed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
        isExceptional: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
        openTimeInMinutes: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          undefined,
        ]),
        closeTimeInMinutes: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          undefined,
        ]),
        openTimeInSeconds: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          undefined,
        ]),
        closeTimeInSeconds: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          undefined,
        ]),
      })),
      undefined,
    ]),
    phoneNumber: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    fasciaId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    fasciaCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    geographic: faker.helpers.arrayElement([
      {
        longitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        latitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        streetViewLongitude: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 20 } }),
          undefined,
        ]),
        streetViewLatitude: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 20 } }),
          undefined,
        ]),
        gpsCoordinates: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      },
      undefined,
    ]),
    newShop: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    code: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  }));

export const getGetStoreScheduleResponseMock = (
  overrideResponse: Partial<StoreOpenDayAndHourScheduleDTO> = {}
): StoreOpenDayAndHourScheduleDTO => ({
  storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  address: faker.helpers.arrayElement([
    {
      street: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      number: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      bus: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      zipCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      city: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      country: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    },
    undefined,
  ]),
  scheduleEntries: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      openingHour: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      closingHour: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      day: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      date: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      closed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      isExceptional: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      openTimeInMinutes: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      closeTimeInMinutes: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      openTimeInSeconds: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      closeTimeInSeconds: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    })),
    undefined,
  ]),
  phoneNumber: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  fasciaId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  fasciaCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  geographic: faker.helpers.arrayElement([
    {
      longitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      latitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      streetViewLongitude: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      streetViewLatitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      gpsCoordinates: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    },
    undefined,
  ]),
  newShop: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  code: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetStoreScheduleServerResponseMock = (
  overrideResponse: Partial<StoreOpenDayAndHourScheduleDTO> = {}
): StoreOpenDayAndHourScheduleDTO => ({
  storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  address: faker.helpers.arrayElement([
    {
      street: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      number: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      bus: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      zipCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      city: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      country: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    },
    undefined,
  ]),
  scheduleEntries: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      openingHour: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      closingHour: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      day: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      date: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      closed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      isExceptional: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      openTimeInMinutes: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      closeTimeInMinutes: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      openTimeInSeconds: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      closeTimeInSeconds: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    })),
    undefined,
  ]),
  phoneNumber: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  fasciaId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  fasciaCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  geographic: faker.helpers.arrayElement([
    {
      longitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      latitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      streetViewLongitude: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      streetViewLatitude: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      gpsCoordinates: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    },
    undefined,
  ]),
  newShop: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  code: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetStoreInfoByStoreIdResponseMock = (overrideResponse: Partial<StoreInfoDTO> = {}): StoreInfoDTO => ({
  storeId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetStoreInfoByStoreIdServerResponseMock = (
  overrideResponse: Partial<StoreInfoDTO> = {}
): StoreInfoDTO => ({
  storeId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetMainWebShopConfigServerResponseMock = (
  overrideResponse: Partial<MainWebShop> = {}
): MainWebShop => ({
  mainWebshopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  businessUnitId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  businessUnit: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  marketId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  displayName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  fasciaId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  fascia: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  orderReference: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ttlBasketReservation: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  phoneNumber: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  invoicingStartDate: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]),
  alwaysShowProducts: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  showMultiFasciaOnPdp: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  exactStockThreshold: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  urls: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
    },
    undefined,
  ]),
  baseUrlImages: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  reviewProviderOverride: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetAllStoresScheduleServerMockHandler = (
  overrideResponse?:
    | Array<StoreOpenDayAndHourScheduleDTO>
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Array<StoreOpenDayAndHourScheduleDTO>> | Array<StoreOpenDayAndHourScheduleDTO>),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/store/openinghours/schedule/all',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAllStoresScheduleServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetStoreScheduleMockHandler = (
  overrideResponse?:
    | StoreOpenDayAndHourScheduleDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<StoreOpenDayAndHourScheduleDTO> | StoreOpenDayAndHourScheduleDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/store/schedule',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetStoreScheduleResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetStoreScheduleServerMockHandler = (
  overrideResponse?:
    | StoreOpenDayAndHourScheduleDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<StoreOpenDayAndHourScheduleDTO> | StoreOpenDayAndHourScheduleDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/public/store/openinghours/schedule',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetStoreScheduleServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetStoreInfoByStoreIdMockHandler = (
  overrideResponse?:
    | StoreInfoDTO
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<StoreInfoDTO> | StoreInfoDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/store/info/:mainWebshop/:storeId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetStoreInfoByStoreIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetStoreInfoByStoreIdServerMockHandler = (
  overrideResponse?:
    | StoreInfoDTO
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<StoreInfoDTO> | StoreInfoDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/public/store/info/:mainWebshop/:storeId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetStoreInfoByStoreIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetMainWebShopConfigServerMockHandler = (
  overrideResponse?:
    | MainWebShop
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<MainWebShop> | MainWebShop),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/mainwebshop/name/:name',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetMainWebShopConfigServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};
export const getConfigurationServiceAPIMock = () => [
  getGetAllStoresScheduleServerMockHandler(),
  getGetStoreScheduleMockHandler(),
  getGetStoreScheduleServerMockHandler(),
  getGetStoreInfoByStoreIdMockHandler(),
  getGetStoreInfoByStoreIdServerMockHandler(),
  getGetMainWebShopConfigServerMockHandler(),
];
